module.exports = require('./lib/autoBind');



// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/node_modules/react-autobind/index.js